import Employee from 'src/app/model/product/employee';
import Address from 'src/app/model/project/address';
import { Role } from 'src/app/model/role';
import { User } from 'src/app/model/user';
import { UserSubmit } from './user-submit';
import { cloneDeep } from 'lodash';
import AddressHelper from 'src/app/helpers/address-helper';
import { OfflineProfilePicture } from './offline-profile-picture';
import { EMPLOYEE_TYPE_CHOICE_ARRAY } from 'src/app/model/employee-type';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { NgForage } from 'ngforage';
import AssetHelper from 'src/app/helpers/asset-helper';

export class EditEmployeeUserHelper {
  private constructor() {}

  public static initializeEmptyUser(): User {
    let toReturn = new User();
    toReturn.employee = new Employee();

    toReturn.roles.push(new Role(<any>'ROLE_USER')); // TODO refactor RoleName to a string enum

    toReturn.employee.address = new Address();
    toReturn.employee.active = true;

    return toReturn;
  }

  public static prepareUserForEdit(user: User): void {
    if (user.employee == null) {
      user.employee = new Employee();
    }
    if (user.employee.address == null) {
      user.employee.address = new Address();
    }
  }

  public static getEmployeeTypeOptions(user: User): EmployeeTypeOption[] {
    const toReturn: EmployeeTypeOption[] = EMPLOYEE_TYPE_CHOICE_ARRAY.map(
      (c) => {
        return {
          label: c.label,
          key: c.key,
          checked: false,
        };
      }
    );

    const optionMap: Map<string, EmployeeTypeOption> = new Map<
      string,
      EmployeeTypeOption
    >(toReturn.map((o) => [o.key, o]));
    if (CollectionHelper.isPopulated(user.employee.types)) {
      user.employee.types.forEach((t) => {
        const matchingOption = optionMap.get(<string>(<unknown>t));
        if (matchingOption != null) {
          matchingOption.checked = true;
        }
      });
    }

    return toReturn;
  }

  public static async prepareOfflineProfilePictureForSubmit(
    offlineProfilePicture: OfflineProfilePicture,
    ngForage: NgForage
  ): Promise<void> {
    const file: File = await ngForage.getItem<File>(
      AssetHelper.getStorageKeyFor(offlineProfilePicture.localFileUuid)
    );
    offlineProfilePicture.base64 = await AssetHelper.extractBase64(file);
  }

  public static prepareUserForSubmit(
    user: User,
    employeeTypeOptions: EmployeeTypeOption[]
  ): void {
    user.employee.types = [];
    employeeTypeOptions.forEach((t) => {
      if (t.checked) {
        user.employee.types.push(<any>t.key);
      }
    });
  }

  public static getCreateOrUpdateBody(
    user: User,
    offlineProfilePicture: OfflineProfilePicture | null
  ): UserSubmit {
    const toReturn: UserSubmit = cloneDeep(user);

    if (offlineProfilePicture != null) {
      toReturn.submittedProfilePicture = offlineProfilePicture;
    }

    if (
      toReturn.employee.address != null &&
      AddressHelper.isEmptyAddress(toReturn.employee.address)
    ) {
      delete toReturn.employee.address;
    }

    return toReturn;
  }
}

export interface EmployeeTypeOption {
  label: string;
  key: string;
  checked: boolean;
}
